import { hot } from 'react-hot-loader/root'
import React from 'react'
import { BrowserRouter, Switch } from 'react-router-dom'
import { IntlProvider } from 'react-intl'
import { withScriptjs } from 'commons/js/components/Map'
import { EPProvider, PromoBannerProvider } from '@elparking/components'
import convertConstantToEPProviderFormat from 'commons/js/util/coverterGlobalConfig'
import { messages } from 'commons/js/messages'
import Routes from 'commons/js/routes/routes'
import { defaultLocale, currentLocale } from 'commons/js/locale'
import DefaultRoute from './components/DefaultRoute'
import { electricChargeSearchParams } from './defaultParams'
import getTheme from 'commons/js/theme/getTheme'

const App = () => (
    <IntlProvider locale={currentLocale} defaultLocale={defaultLocale} messages={messages[currentLocale]}>
        <EPProvider theme={getTheme()} {...convertConstantToEPProviderFormat()}>
            <PromoBannerProvider>
                <BrowserRouter>
                    <Switch>
                        <DefaultRoute
                          path={Routes.chargingPointSearchPath()}
                          defaultParams={electricChargeSearchParams}
                    />
                    </Switch>
                </BrowserRouter>
            </PromoBannerProvider>
        </EPProvider>
    </IntlProvider>
)

const AppWithScript = withScriptjs(App)

export default hot(AppWithScript)
